import { render, staticRenderFns } from "./assessmentShow.vue?vue&type=template&id=76a46969&scoped=true"
import script from "./assessmentShow.vue?vue&type=script&lang=js"
export * from "./assessmentShow.vue?vue&type=script&lang=js"
import style0 from "./assessmentShow.vue?vue&type=style&index=0&id=76a46969&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a46969",
  null
  
)

export default component.exports